export default __webpack_public_path__ + "static/media/error.5f872760.svg";